import { fetchOwa } from 'api';
import { useQuery } from 'react-query';

function useOwaFetch() {
  return useQuery({
    queryKey: ['owa'],
    queryFn: fetchOwa,
  });
}

export default useOwaFetch;
